// Components
import HeroSection from "../components/home/HeroSection";
import AboutSection from "../components/home/AboutSection";
import CoreTeamSection from "../components/home/CoreTeamSection";
import PartnersSection from "../components/home/PartnersSectiion";
import FooterSection from "../components/home/FooterSection";
import ContactSection from "../components/home/ContactUsSection";

function HomePage() {
  return (
    <div>
      {/* HERO  */}
      <HeroSection />

      {/* ABOUT */}
      <AboutSection />

      {/* CORE TEAM */}
      <CoreTeamSection />

      {/* PARTNERS */}
      <PartnersSection />

      {/* CONTACT */}
      <ContactSection />

      {/* FOOTER */}
      <FooterSection />
    </div>
  );
}

export default HomePage;
